import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicDialogInput,
  DynamicEmailInput
} from '../software-dynamic-version-3/mainSection-multiple-inputs-v-3';
import DynamicInputGrid from '../software-dynamic-version-3/popup-input-grid-v-3';
import ListButtonPopupList from '../software-dynamic-version-3/list-button-popup-list-v-3';

import voucherService from './voucher.service';


let updateDetails = []
const VoucherAdd = (props) => {
    console.log(props)
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
  
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key], // Spread the inner object to update its properties
          };
        }
      });
  
      return updatedValues;
    });
  };
  
  
  const [inputProps, setInputProps] = useState({
  
  
    CallGridDataSource:{name: 'CallGridDataSource',   value: false },
    GridDataSource:{name: 'GridDataSource',   value: [] },

    MainVoucherID:{name: 'MainVoucherID',   value: props.MainVoucherID || undefined },

    CompanyID:{name: 'CompanyID',   value: props.CompanyID || '' ,enabled:false},
    VoucherID:{name: 'VoucherID',   value: props.VoucherID || '' ,enabled:false},

    VoucherType:{name: 'VoucherType',   value: props.Type  ,enabled:false},
    
    VoucherDate:{name: 'VoucherDate',   value: props.VoucherDate || 'currentDate' },

    AccountTitleCashBank:{
      name:{id:'AccountIDCashBank',value:'AccountTitleCashBank'},
      caption: 'Select Account Cash Bank',
      value:{id: props.AccountIDCashBank || undefined ,value:props.AccountTitleCashBank || ''},
      dataSource: {type:'Route',route: 'AccountCashBankVoucher'},
      // isControlBlur:true
        },
    GetBill:{name:'GetBill', caption:'Get Bill', isClicked:false ,enabled:true , show:false}

      }
    );

    
    // useEffect(()=>{
  
      // setTimeout(()=>{
      //   document.getElementById('AccountTitleCashBank').addEventListener('keydown',(tab)=>{
      //   console.log(tab)
      //   if(tab.key == 'Tab'){
      // document.getElementById('VoucherDetailGrid_add').click()
      //   }
      // })
    // },1000)

    // },[inputProps.AccountTitleCashBank.value])
    useEffect(() => {
      
      return () => {
        // cleanup code here (if needed)
        console.log(updateDetails);
        console.log(inputProps.GridDataSource.value);
        let inputProp = {}
        setInputProps((prevValues) => {
          console.log(prevValues);
          inputProp = prevValues
          return {...prevValues
          // ['MainInvoiceID']: {...prevValues['MainInvoiceID'] ,value :response.data.MainInvoiceID }    
        }});
        console.log(inputProp)
        if(inputProp.GridDataSource?.value){
        props.sendDetail([...inputProp.GridDataSource.value])
        }
      };
    }, []);
    
    const getVoucherIDValue = async ()=>{
      try {
        const response =   await voucherService.getVoucherIDValue(props.CompanyID , props.Type) ;
        if (response.data || response.data.recordset) {
          console.log(response)
          
          updateMainSecionsValue({VoucherID: {value:response.data.recordset[0]?.NewVoucherID}})
        }
          else {
          console.error("Invalid response structure:", response);
        }
       } catch (error) {
        }
    }


// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  if(name == 'VoucherID'  && props.isAdd  == true){

    return await getVoucherIDValue()
  }
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {

 
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
   
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  if(name == 'VoucherDate'  && props.Type == 'JV'){
    setTimeout(()=>document.getElementById('VoucherDetailGrid_add').click(),100)
    

  }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };

  let btn = { Id:'GetBills',Content:'Get Bills',BgColor:'#2c842d' ,Color:'#f4f4f4',
    Input:{
    Route:'GetBills' ,
    Title:'Get Bills', 
    Security:props.Type == 'JV' ? 'Journal Voucher': props.Type == 'RV' ? 'Receipt Voucher': 'Payment Voucher',
    Width:'1000px',
    onClosing:async (e)=>{
      console.log(e)
      console.log(updateDetails)
      document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
      if(inputProps.MainVoucherID.value == undefined){
      updateMainSecionsValue({CallGridDataSource:{value:true}})
      updateMainSecionsValue({GridDataSource:{value:[...inputProps.GridDataSource.value,...updateDetails]}})
      updateDetails = [...inputProps.GridDataSource.value,...updateDetails]
      setTimeout(()=>updateMainSecionsValue({CallGridDataSource:{value:false}}),200)
    }else{
      const data = {
        MainVoucherID: inputProps.MainVoucherID.value,
        CompanyID: inputProps.CompanyID.value,
        VoucherID: inputProps.VoucherID.value,
        VoucherType: inputProps.VoucherType.value,
        VoucherDate: inputProps.VoucherDate.value,
        AccountIDCashBank: inputProps.AccountTitleCashBank.value.id,
      
        // Map updateDetails to details array, adding common properties to each item
        details: [...updateDetails],
      
        // Nested params object
        params: {
          FromDate: '01-JAN-01',
          ToDate: moment().add(1, 'days').format('DD-MMM-YY'),
          VoucherType: props.Type,
          MainVoucherID: inputProps.MainVoucherID.value,
          VoucherID: 0,
          AccountIDCashBank: 0,
          AccountID: 0,
          PurchaseInvoiceID: 0,
          SaleInvoiceID: 0,
          VoucherDetailID: 0
        }
      };
      
      let response = await voucherService.addGridVoucher(data)
      console.log(response);
      if(response){
        updateMainSecionsValue({
          CallGridDataSource: {value:true},
          GridDataSource: {value:response.data.Recordsets.recordset || []}
        })
        setTimeout(()=>updateMainSecionsValue({CallGridDataSource: {value:false},}),100)


          if(props.Type == 'JV'){
          let dataSourceGrid =response.data.Recordsets.recordset
          const totalDebit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Debit, 0);
          const totalCredit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Credit, 0);
          if(totalCredit == totalDebit){
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
            
          }else{
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
            }
            }
          setTimeout(()=>document.getElementById('VoucherDetailGrid_add').click(),700)
      }
    }}

  }}
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.MainVoucherID, setInputProps },ColumnSize:0},

    // {Input: props.isAdd == true ? HiddenComponent :  TextComponent,Props: {...inputProps.VoucherID, onCreated:handleInputCreated,setInputProps },ColumnSize:props.isAdd == true ? 0 : 4},
    {Input:HiddenComponent,Props: {...inputProps.CompanyID,setInputProps },ColumnSize:0},
    {Input:HiddenComponent,Props: {...inputProps.VoucherID,setInputProps, onCreated:handleInputCreated },ColumnSize:0},
    { Input: HiddenComponent,Props: {...inputProps.VoucherType, setInputProps },ColumnSize:0},

    
    {Input: DateComponent,Props: {...inputProps.VoucherDate,onBlur:handleInputBlur ,setInputProps }},
    // {Input:props.Type == 'JV' ? HiddenComponent : DropdownComponent,Props: {...inputProps.AccountTitleCashBank, onChange:handleInputChange,setInputProps },ColumnSize:props.Type == 'JV' ? 0:4},
    {Input: props.Type == 'JV' ? HiddenComponent : DropdownComponent,Props: {...inputProps.AccountTitleCashBank,setInputProps ,onFocus:handleInputFocus,onBlur:handleInputBlur},ColumnSize:props.Type == 'JV' ? 0:4},
    
    

    { Input: props.Type == 'JV'    ? HiddenComponent : 
      ()=>{
      return(<ListButtonPopupList
            key={1} // Use a unique key for each button
            Id={btn.Id}
            Route={btn?.Input?.Route}
            Security={btn?.Input?.Security}
            OnClosed={btn?.Input?.onClosing}
            Title={btn?.Content} // Use the dynamic title from the button object
            InputTitle={btn?.Input?.Title} // Use the dynamic input title from the button object
            // Width={btn?.Input?.Width} // Use the dynamic input title from the button object
            SelectedRow={{}}
            BgColor={btn?.BgColor}
            Color={btn?.Color}
            sendDetails={(data)=>{
              console.log(data)
              // updateMainSecionsValue({StoreDetail:{value:[...data]}})
              // updateDetails([...data])
              updateDetails = [...data]
            }}
            onBlur={(e,dialogType)=>{
              console.log(e)
              console.log(dialogType)
              setTimeout(()=>{
                document.getElementById('VoucherDetailGrid_add') && !dialogType && document.getElementById('VoucherDetailGrid_add').click()
              },1000)
            }}
            Type={props.Type }
        />)},Props: {...inputProps.GetBill, setInputProps },ColumnSize:4},

    
    
    
    
    
  ];




// Detail Section Start

let addColumns =[
  { field:"MainTransferID",headerText:'Main Tranfer ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  

  { field:"AccountTitle",headerText:'Account Title',width:'120px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
    caption:'Account Title' ,source:{type:"Route",dataSource:'AccountTitleVoucher'} , field:{id:'AccountID',value:'AccountTitle'}, filter:{},
    // select:{source:{type:'Function',dataSource:{function:voucherService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  }
  }]},
  { field:"AccountID",headerText:'Account ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  
  { field:"BillNo",headerText:'Bill No',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[{allowEditing:false}]},
  { field:"Debit",headerText:'Debit',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0.00,'format':'n2','editType':'numericedit',edit:{format:'n2'},'visible':props.Type == 'JV' || props.Type == 'PV'}]},
  
  { field:"Credit",headerText:'Credit',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0.00 , 'format':'n2','editType':'numericedit',edit:{format:'n2'},'visible':props.Type == 'JV' || props.Type == 'RV'}]},
  
  { field:"PurchaseInvoiceID",headerText:'Account ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"SaleInvoiceID",headerText:'Account ID',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  
  
  { field:"DetailRemarks",headerText:'Detail Remarks',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[{initialValue:'-',endEdit:true}]},
  

  

]
const callGridDataSource =  async (id)=>{
updateMainSecionsValue({CallGridDataSource:{value:true}})
  let data ={
        FromDate:'01-JAN-01' ,
        ToDate: moment().add(1, 'days').format('DD-MMM-YY'),
        VoucherType:props.Type,
        MainVoucherID:id,
        VoucherID:0,
        AccountIDCashBank:0,
        PurchaseInvoiceID:0,
        SaleInvoiceID:0,
        AccountID:0,
        VoucherDetailID:0,
    }
    console.log(data)
  let response =await voucherService.getGridDataSource(data)
  console.log(response)
  if(response && response.data.recordset){
updateMainSecionsValue({GridDataSource:{value:response.data.recordset}})
setTimeout(()=>updateMainSecionsValue({CallGridDataSource:{value:false}}),200)
  }else{
    updateMainSecionsValue({GridDataSource:{value:[]}})
  }


}

useEffect(()=>{
    if(props.isAdd == false){
      console.log(props.MainVoucherID)
      callGridDataSource(props.MainVoucherID)
    }
},[])
// EDIT TEMPLATE CODE HERE START
//8*********************************
//8*********************************
//8*********************************
//8*********************************
//8*********************************
//8*********************************



useEffect(()=>{
  setTimeout(()=>{
if(props.isAdd == true){

  document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
}
},500)

},[])
     
const addActionComplete = async (grid, args ,setDataSourceState ,getListService  , selectedRow, selectRowByID,
      startEdit,
      addUserLog,
      editUserLog,
      dataSourceStateLength )=>{
    
  console.log(args)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){

       
  
}
  
  
  console.log(inputProps)
  
  
  console.log(args)
  console.log(selectedRow)
  if(args.requestType == 'save' || args.requestType == 'cancel'){
    // document.getElementById('VoucherGrid_dialogEdit_wrapper_dialog-content').scrollBottom = 0;
    document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';

}
  if(args.requestType == 'save'){
    let inputProp = {}
        setInputProps((prevValues) => {
          console.log(prevValues);
          inputProp = prevValues
          return {...prevValues
          // ['MainInvoiceID']: {...prevValues['MainInvoiceID'] ,value :response.data.MainInvoiceID }    
        }});
    console.log(inputProp)
    let details;

    if (args.action === 'edit') {
      if (inputProp.MainVoucherID.value) {
        // Case 1: MainVoucherID is defined — insert updated data at the top
        details = [
          {
            AccountID: args.data.AccountID,
            Debit: args.data.Debit || 0,
            Credit: args.data.Credit || 0,
            DetailRemarks: args.data.DetailRemarks,
            PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : args.data.PurchaseInvoiceID == undefined ? null : args.data.PurchaseInvoiceID,
            SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : args.data.SaleInvoiceID == undefined ? null : args.data.SaleInvoiceID,
            VoucherDetailID: args.data?.VoucherDetailID
          },
          ...(inputProp.GridDataSource.value || [])
        ];
      } else {
        // Case 2: MainVoucherID is undefined — update the existing item at the same index
        let gridData = [...(inputProp.GridDataSource.value || [])];
        gridData[args.rowIndex] = {
          AccountID: args.data.AccountID,
          Debit: args.data.Debit || 0,
          Credit: args.data.Credit || 0,
          DetailRemarks: args.data.DetailRemarks,
          PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : args.data.PurchaseInvoiceID == undefined ? null : args.data.PurchaseInvoiceID,
          SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : args.data.SaleInvoiceID == undefined ? null : args.data.SaleInvoiceID,
          VoucherDetailID: args.data?.VoucherDetailID
        };
        details = gridData;
      }
    } else {
      // For other actions (not 'edit'), insert normally at the top
      details = [
        {
          AccountID: args.data.AccountID,
          Debit: args.data.Debit || 0,
          Credit: args.data.Credit || 0,
          DetailRemarks: args.data.DetailRemarks,
          PurchaseInvoiceID: props.Type === 'RV' || props.Type === 'JV' ? null : args.data.PurchaseInvoiceID == undefined ? null : args.data.PurchaseInvoiceID,
          SaleInvoiceID: props.Type === 'PV' || props.Type === 'JV' ? null : args.data.SaleInvoiceID == undefined ? null : args.data.SaleInvoiceID,
          VoucherDetailID: args.data?.VoucherDetailID
        },
        ...(inputProp.GridDataSource.value || [])
      ];
    }
      
    let  data = {
      MainVoucherID:inputProp.MainVoucherID.value,
      CompanyID	:inputProp.CompanyID.value,
      VoucherID	:inputProp.VoucherID.value,
      VoucherType	:inputProp.VoucherType.value,
      VoucherDate	:inputProp.VoucherDate.value,
      // AccountIDCashBank	:props.Type  == 'JV' ? inputProp.AccountTitleCashBank.value : inputProp.AccountTitleCashBank.value.id,
      AccountIDCashBank	: props.Type == 'JV' ? null : inputProp.AccountTitleCashBank.value.id,
      
      
      //DETAIL
      details:details,
    params:{
      FromDate:'01-JAN-01' ,
      ToDate:moment().add(1, 'days').format('DD-MMM-YY'),
      VoucherType:props.Type,
      MainVoucherID:inputProp.MainVoucherID.value,
      VoucherID:  0,
      AccountIDCashBank:0,
      AccountID:0,
      PurchaseInvoiceID:0,
      SaleInvoiceID:0,
      VoucherDetailID:0 
    }
      

}
console.log(data)
if(args.action == 'add'){

  const response = data.MainVoucherID == undefined ? await voucherService.addVoucher(data) : await voucherService.addGridVoucher({...data,details:[data.details[0]]});
          console.log(response)
          if(data.MainVoucherID == undefined){
          updateMainSecionsValue({MainVoucherID: {value:response.data.MainVoucherID}})
        }
        updateMainSecionsValue({
          CallGridDataSource: {value:true},
          GridDataSource: {value:response.data.Recordsets.recordset || []}
        })
        setTimeout(()=>updateMainSecionsValue({CallGridDataSource: {value:false},}),100)


          if(props.Type == 'JV'){
          let dataSourceGrid =response.data.Recordsets.recordset
          const totalDebit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Debit, 0);
          const totalCredit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Credit, 0);
          if(totalCredit == totalDebit){
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
            
          }else{
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
            }
            }
          setTimeout(()=>document.getElementById('VoucherDetailGrid_add').click(),700)

}
if(args.action == 'edit'){
  const response = data.MainVoucherID == undefined ? await voucherService.addVoucher(data) : await voucherService.editGridVoucher({...data.details[0],MainVoucherID:inputProp.MainVoucherID.value, params:data.params});
  console.log(response)
    if(data.MainVoucherID == undefined){
      updateMainSecionsValue({MainVoucherID: {value:response.data.MainVoucherID}})
    }

          updateMainSecionsValue({CallGridDataSource: {value:true},
            GridDataSource: {value:response.data.Recordsets.recordset}
          })
          setTimeout(()=>updateMainSecionsValue({CallGridDataSource: {value:false},}),100)
          

          if(props.Type == 'JV'){
          let dataSourceGrid =grid.dataSource
          const totalDebit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Debit, 0);
          const totalCredit = dataSourceGrid.reduce((sum, dataSourceGrid) => sum + dataSourceGrid.Credit, 0);
          if(totalCredit == totalDebit){
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
            
          }else{
            document.querySelector('#VoucherGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
            }
            }
}
  console.log(data)

    console.log(inputProp)
  }
}



// Usage in your main component


      
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`${props.Type == 'JV' ? `Journal Voucher` : props.Type == 'RV' ? `RECEIPT VOUCHER` : `PAYMENT VOUCHER`} ${props.isAdd == true ? `  - Add` : ` - Edit`}`} Inputs={inputsList}/>
       {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging  */}
       <br/>
        
      <DynamicInputGrid
        Id='VoucherDetail'
        
        ColumnsList={addColumns}
        GridDataSource= {[
          {
        DataSourceType:inputProps.CallGridDataSource.value ? 'Data' : 'REST',
        DataSource:  inputProps.GridDataSource.value,
        // CreateColumns: [{columnName:'IsEdit',columnValue:false}]
         }]
  }
        DefaultSortedColumnName={'VoucherDetailID'}
      
        ListActionComplete={addActionComplete}
        
        ToolbarClicking ={(grid,args,selectedRows,getListService,saveData,dataSource)=>{
          console.log(grid.dataSource)
          console.log(args)
          console.log(selectedRows)
          console.log(getListService)
          console.log(saveData)
          console.log(dataSource)
          if(args.name == 'DeletedCompleted' && dataSource.length > 0){
            
            updateMainSecionsValue({GridDataSource:{value:dataSource}})
          }


        }}
        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
        AllowTemplate={false}
        ToolbarOption={['Add','Edit','Delete','Update','Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false}
        AllowPdfExport={false} 
        ShowColumnChooser={false}
        AllowPaging={true}
        AllowDataBound={false}
        ListSecurity={'ListSecurity'}
        AddSecurity={'VoucherList'}
        EditSecurity={'VoucherList'}
        DeleteSecurity={'VoucherList'}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
        GroupColumns={[]} 
        ListDelete={[]}
        DeleteType={'hard'} 
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        GridSumColumns={[]}
        AllowGridSum={true}
            {...props}
            ></DynamicInputGrid>
    </div>
  );
}; 

export default VoucherAdd;
